import { useState } from "react";
import { Form, Button, Alert } from "react-bootstrap";
import { loginBac, registrarUsuarioBac, restablecerPasswordBac } from "../api/bacAuthAPI";
import { useBacAuth } from "../../context/BacAuthContext";
import { APP_VERSION } from "../../version";

const CAJA = {
  position: "fixed", inset: 0, background: "#eef1e7", zIndex: 3000,
  display: "flex", alignItems: "center", justifyContent: "center", padding: 20,
};
const TARJETA = { background: "#fff", borderRadius: 16, padding: "36px 32px", maxWidth: 380, width: "100%", boxShadow: "0 10px 40px rgba(0,0,0,.12)" };

export default function BacLogin() {
  const [vista, setVista] = useState("login"); // "login" | "registro" | "restablecer"

  return (
    <div style={CAJA}>
      <div style={TARJETA}>
        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <div style={{ fontSize: 34, marginBottom: 6 }}>🔎</div>
          <h5 style={{ fontWeight: 800, color: "#16342a", margin: 0 }}>App BAC</h5>
        </div>

        {vista === "login" && <FormLogin irARegistro={() => setVista("registro")} irARestablecer={() => setVista("restablecer")} />}
        {vista === "registro" && <FormRegistro volver={() => setVista("login")} />}
        {vista === "restablecer" && <FormRestablecer volver={() => setVista("login")} />}

        <div className="text-center text-muted mt-3" style={{ fontSize: 10.5 }}>
          v{APP_VERSION}
        </div>
      </div>
    </div>
  );
}

function FormLogin({ irARegistro, irARestablecer }) {
  const { login } = useBacAuth();
  const [correo, setCorreo] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(false);

  const entrar = async (e) => {
    e.preventDefault();
    setError("");
    setCargando(true);
    try {
      const res = await loginBac(correo, password);
      login(res.data.token, res.data.usuario);
    } catch (err) {
      setError(err.response?.data?.message || "No se pudo iniciar sesión. Revisa tu conexión.");
    } finally {
      setCargando(false);
    }
  };

  return (
    <>
      <Form onSubmit={entrar}>
        <Form.Group className="mb-3">
          <Form.Label style={{ fontSize: 12.5 }}>Correo electrónico</Form.Label>
          <Form.Control type="email" value={correo} onChange={e => setCorreo(e.target.value)} autoFocus required style={{ fontSize: 16 }} />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label style={{ fontSize: 12.5 }}>Contraseña</Form.Label>
          <Form.Control type="password" value={password} onChange={e => setPassword(e.target.value)} required style={{ fontSize: 16 }} />
        </Form.Group>

        {error && <Alert variant="danger" className="py-2" style={{ fontSize: 12.5 }}>{error}</Alert>}

        <div className="d-grid">
          <Button type="submit" disabled={cargando} style={{ background: "#16342a", border: "none", fontWeight: 700 }}>
            {cargando ? "Entrando..." : "Entrar"}
          </Button>
        </div>
      </Form>

      <div className="d-flex justify-content-between mt-3">
        <button onClick={irARegistro} className="btn btn-link p-0" style={{ fontSize: 12 }}>Crear usuario</button>
        <button onClick={irARestablecer} className="btn btn-link p-0" style={{ fontSize: 12 }}>¿Olvidaste tu contraseña?</button>
      </div>
    </>
  );
}

function FormRegistro({ volver }) {
  const [form, setForm] = useState({ nombre: "", correo: "", cedula: "", password: "" });
  const [error, setError] = useState("");
  const [exito, setExito] = useState("");
  const [cargando, setCargando] = useState(false);

  const enviar = async (e) => {
    e.preventDefault();
    setError(""); setExito("");
    setCargando(true);
    try {
      const res = await registrarUsuarioBac(form);
      setExito(res.data.message);
    } catch (err) {
      setError(err.response?.data?.message || "No se pudo crear la cuenta. Revisa tu conexión.");
    } finally {
      setCargando(false);
    }
  };

  if (exito) {
    return (
      <div className="text-center">
        <div style={{ fontSize: 34, marginBottom: 10 }}>✅</div>
        <p style={{ fontSize: 13.5 }}>{exito}</p>
        <Button variant="outline-secondary" size="sm" onClick={volver}>Volver a iniciar sesión</Button>
      </div>
    );
  }

  return (
    <Form onSubmit={enviar}>
      <div className="fw-bold mb-2" style={{ fontSize: 13 }}>Crear usuario</div>
      <p className="text-muted" style={{ fontSize: 11.5 }}>Tu cuenta queda pendiente hasta que un administrador la apruebe.</p>

      <Form.Group className="mb-2">
        <Form.Control placeholder="Nombre completo" value={form.nombre} onChange={e => setForm(p => ({ ...p, nombre: e.target.value }))} required style={{ fontSize: 16 }} />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Control type="email" placeholder="Correo electrónico" value={form.correo} onChange={e => setForm(p => ({ ...p, correo: e.target.value }))} required style={{ fontSize: 16 }} />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Control placeholder="N° de cédula" value={form.cedula} onChange={e => setForm(p => ({ ...p, cedula: e.target.value }))} required style={{ fontSize: 16 }} />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Control type="password" placeholder="Contraseña (mínimo 6 caracteres)" value={form.password} onChange={e => setForm(p => ({ ...p, password: e.target.value }))} required style={{ fontSize: 16 }} />
      </Form.Group>

      {error && <Alert variant="danger" className="py-2" style={{ fontSize: 12.5 }}>{error}</Alert>}

      <div className="d-grid mb-2">
        <Button type="submit" disabled={cargando} style={{ background: "#16342a", border: "none", fontWeight: 700 }}>
          {cargando ? "Creando..." : "Crear cuenta"}
        </Button>
      </div>
      <div className="text-center">
        <button type="button" onClick={volver} className="btn btn-link p-0" style={{ fontSize: 12 }}>Volver a iniciar sesión</button>
      </div>
    </Form>
  );
}

function FormRestablecer({ volver }) {
  const [form, setForm] = useState({ correo: "", cedula: "", nuevaPassword: "" });
  const [error, setError] = useState("");
  const [exito, setExito] = useState("");
  const [cargando, setCargando] = useState(false);

  const enviar = async (e) => {
    e.preventDefault();
    setError(""); setExito("");
    setCargando(true);
    try {
      const res = await restablecerPasswordBac(form);
      setExito(res.data.message);
    } catch (err) {
      setError(err.response?.data?.message || "No se pudo restablecer. Revisa tu conexión.");
    } finally {
      setCargando(false);
    }
  };

  if (exito) {
    return (
      <div className="text-center">
        <div style={{ fontSize: 34, marginBottom: 10 }}>✅</div>
        <p style={{ fontSize: 13.5 }}>{exito}</p>
        <Button variant="outline-secondary" size="sm" onClick={volver}>Volver a iniciar sesión</Button>
      </div>
    );
  }

  return (
    <Form onSubmit={enviar}>
      <div className="fw-bold mb-2" style={{ fontSize: 13 }}>Restablecer contraseña</div>
      <p className="text-muted" style={{ fontSize: 11.5 }}>Verificamos tu identidad con tu correo y tu número de cédula.</p>

      <Form.Group className="mb-2">
        <Form.Control type="email" placeholder="Correo electrónico" value={form.correo} onChange={e => setForm(p => ({ ...p, correo: e.target.value }))} required style={{ fontSize: 16 }} />
      </Form.Group>
      <Form.Group className="mb-2">
        <Form.Control placeholder="N° de cédula" value={form.cedula} onChange={e => setForm(p => ({ ...p, cedula: e.target.value }))} required style={{ fontSize: 16 }} />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Control type="password" placeholder="Nueva contraseña (mínimo 6 caracteres)" value={form.nuevaPassword} onChange={e => setForm(p => ({ ...p, nuevaPassword: e.target.value }))} required style={{ fontSize: 16 }} />
      </Form.Group>

      {error && <Alert variant="danger" className="py-2" style={{ fontSize: 12.5 }}>{error}</Alert>}

      <div className="d-grid mb-2">
        <Button type="submit" disabled={cargando} style={{ background: "#16342a", border: "none", fontWeight: 700 }}>
          {cargando ? "Guardando..." : "Restablecer contraseña"}
        </Button>
      </div>
      <div className="text-center">
        <button type="button" onClick={volver} className="btn btn-link p-0" style={{ fontSize: 12 }}>Volver a iniciar sesión</button>
      </div>
    </Form>
  );
}